<div class="submenu container-fluid clearfix">
  <ul class="navbar-nav ml-auto wrap">
    <li class="nav-item" routerLinkActive="active">
      <a class="nav-link" [routerLink]="'onboarding'">
        <span>Onboarding</span>
      </a>
    </li>
    <li class="nav-item" routerLinkActive="active">
      <a class="nav-link" [routerLink]="'stadium'">
        <span>Stadium View</span>
      </a>
    </li>
    <li class="nav-item" routerLinkActive="active">
      <a class="nav-link" [routerLink]="'storyboards'">
        <span>Storyboards</span>
      </a>
    </li>
    <li class="nav-item" routerLinkActive="active">
      <a class="nav-link" [routerLink]="'topics'">
        <span>Topics</span>
      </a>
    </li>
    <li class="nav-item" routerLinkActive="active">
      <a class="nav-link" [routerLink]="'useful-links'">
        <span>Useful links</span>
      </a>
    </li>
  </ul>
</div>
